import React, { useState } from 'react';
import { PictureIcon } from '../../../../assets/icons';
import { Translate } from '../../../../language';
import { useHistory } from "react-router-dom";
import style from './Room.module.css'
import Button from '../../../../utils/components/Button/Button';
import ImageNameDescription from '../../../../utils/components/ImageNameDescription/ImageNameDescription';
import SeeRoom from '../../../../components/Rooms/SeeRoom';
import useModal from '../../../../utils/hooks/useModal';
import Options from '../../../../utils/components/Options/Options';
import { useSelector } from 'react-redux';
import localStorage from '../../../../utils/hooks/useLocalStorage';
const RootOneRoom = ({ match, conversation, membersRoom, roomInfo, routes, categories, rooms, isLoadingRoom, loadingInRoom, inRoom }) => {
  const history = useHistory()
  const [refRules, isShowRules, setIsShowRules] = useModal(false)
  const [userReported, setUserReported] = useState(null)
  const [refReport, isShowReport, setIsShowReport] = useModal(false)
  const [userToReport, setUserToReport] = useState(null);
  const { userInfo } = useSelector(state => state.userInfo)
  if (isLoadingRoom || loadingInRoom)
    return (
      <div className={style.content_error}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    )
  if (roomInfo.isError) {
    return (
      <div className={style.content_error}>
        no encontrado
      </div>
    )
  }
  if (!loadingInRoom && inRoom.is ===false && inRoom.roomId) {
    //    history.push(`/Rooms/Join${inRoom.zoneId}`)
    history.push(`/Rooms/Join/${inRoom.roomId}`)

  }

  const reportUseropt = (member) => {
    //setUserReported(member)
    setUserToReport(member)
  }
  return (
    <div className={style.content_general}>
      <div className={style.content_left}>
        <div className={style.content_icon}><PictureIcon className={style.icon} /></div>
        <div className={style.content_list_rooms}>
          <div className={style.title}>
            {Translate('chatRoom', 'es')}

          </div>
          <div className={style.roomInfo}>
            <div className={style.create}>
              <div className={style.green}>{roomInfo.name}</div>
            </div>
            <div className={style.roomInfo}>
              <div>{Translate('category', 'es')}</div>
              <div className={style.purple}> {roomInfo.chatCategoriesID?.name}</div>
            </div>
            <div>
              {
                roomInfo.privacy ===0 && Translate('public_f', 'es')
              }
              {
                roomInfo.privacy ===1 && Translate('private_f', 'es')
              }
            </div>
          </div>
          <Button text={'Miembros'} classNameContent={style.content_button} />
          <div className={style.list_item}>
            {membersRoom.map(member => {
              let src = null
              let id = null;
              let name = null
              let lastname = null
              let type = null
              if (member.memberType ==="user") {
                id = member.memberUserId._id
              type ="EcoAmigo"
                name = member.memberUserId.name.split(" ")[0]
                lastname = member.memberUserId.lastname.split(" ")[0]
                src = member.memberUserId.picture && member.memberUserId.picture.url && member.memberUserId.picture.url.small
              }
              if (member.memberType ==="franchise") {
                type ="EcoTienda"
                id = member.memberFranchiseId._id
                name = member.memberFranchiseId.socialReason
                src = member.memberFranchiseId.picture && member.memberFranchiseId.picture.url && member.memberFranchiseId.picture.url.small
              }
              if (member.memberType ==="representative") {
                type ="EcoMaster"
                id = member.memberRepresentativeId._id
                name = member.memberRepresentativeId.userID.name.split(" ")[0]
                lastname = member.memberRepresentativeId.userID.lastname.split(" ")[0]
                src = member.memberRepresentativeId.userID.picture &&
                  member.memberRepresentativeId.userID.picture.url &&
                  member.memberRepresentativeId.userID.picture.url.small
              }
              if (member.memberType ==="warehouse") {
                type ="EcoCeo"
                id = member.memberWarehouseId._id
                name = member.memberWarehouseId.name
                src = member.memberWarehouseId.profileId.picture &&
                  member.memberWarehouseId.profileId.picture.url &&
                  member.memberWarehouseId.profileId.picture.url.small
              }
              return (
                <div className='column' key={member._id}>
                  <ImageNameDescription
                    key={member._id}
                    type={"header-message parent-width pr-1 pl-1"}
                    description ={type}
                    shouldDscriptionEllipsis = {false}
                    srcImage={src}
                    firstName={name}
                    secondName={lastname}
                    typeOneText="purple"

                  />
                  <Options
                    options={[
                      ((id !== localStorage().getItem('idUser'))

                        && id !== localStorage().getItem('idProfile')
                      ) && {
                        text: "Reportar",
                        onClick: (e) => {
                          reportUseropt(member)
                          setIsShowReport(true)

                        }
                      }
                    ]}
                    style={{
                      position: "relative",
                      marginLeft: "auto"
                    }} />
                </div>
              )
            }
            )}
          </div>

          <Button text={'Ver reglas'}
            onClick={(e) => {
              e.preventDefault(); e.stopPropagation();
              setIsShowRules(true)
            }}
            classNameContent={style.content_button} theme={'white'} />
          <ModalRules
            displayModal={isShowRules}
            close={() => setIsShowRules(false)}
            rules={roomInfo.rules}
          />
          {
            (roomInfo.adminID === localStorage().getItem('idProfile') || roomInfo.moderatorId === localStorage().getItem('idProfile')) && (
              <Button onClick={(e) => {
                e.preventDefault(); e.stopPropagation();
                history.push(`/Rooms/Admin/${roomInfo._id}`)
              }} text={'Administrar'} classNameContent={style.content_button} theme={'white'} />

            )
          }
        </div>
      </div>
      <div className={style.content_right}>
        <SeeRoom
          userToReport={userToReport}
          setUserToReport={setUserToReport}

          refReport={refReport} isShowReport={isShowReport} setIsShowReport={setIsShowReport}

          userReported={userReported} conversation={conversation} membersRoom={membersRoom} roomInfo={roomInfo} match={match} />
      </div>
    </div>
  );
};

export default RootOneRoom;
const ModalRules = ({ displayModal, close, rules = "" }) => {
  const rulesArray = rules.split("\n")
  const divStyle = {
    display: displayModal ? 'block' : 'none'
  }
  return (
    <div className={"modal"} style={divStyle} onClick={close}>
      <div className="modal-content">
        <div className={style.title}>Reglas</div>
        <div>
          {
            rulesArray.map((rule, index) => (
              <p key={index}>{rule}</p>
            ))
          }
        </div>

      </div>

    </div>)

}